/* Concierge Ostria : reponses automatiques a partir de faits verifies, sans serveur ni cle API. */
(() => {
  const root = document.getElementById('o-concierge');
  if (!root) return;

  const EMAIL = 'ostriacontact@gmail.com';
  // Les frais viennent des reglages Shopify : ostria.js les lit en direct.
  let shippingNote = 'Vous choisissez votre option de livraison à l’étape de paiement, où les frais sont affichés.';
  const withShipping = (text) => text.replace('[[livraison]]', shippingNote);
  const loadShipping = () =>
    window.ostriaShipping?.().then((list) => {
      if (list.length) shippingNote = `Au choix à l’étape de paiement : ${list.map((option) => `${option.title}, ${option.price}`).join(' ; ')}.`;
    });
  const { price, available, page, variant, kb } = root.dataset;
  const inStock = available === 'true';
  const FREE = 250;
  const EASTERN = '٠١٢٣٤٥٦٧٨٩';
  const eastern = (value) => String(value).replace(/\d/g, (digit) => EASTERN[Number(digit)]);
  const link = (href, label) => `<a href="${href}">${label}</a>`;
  const buy = inStock ? `<a class="o-chat__cta" href="/cart/${variant}:1">Commander ma Classe 01</a>` : '';
  const mail = link(`mailto:${EMAIL}?subject=Question%20sur%20Ostria`, EMAIL);

  const normalize = (value) =>
    value.toLowerCase().replace(/[’']/g, ' ').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();

  // Ecriture SMS et abreviations, ramenees a leur forme complete avant l'analyse.
  const SHORT = {
    pk: 'pourquoi', pq: 'pourquoi', pkoi: 'pourquoi', pourkoi: 'pourquoi', prq: 'pourquoi', pcq: 'parce que', pck: 'parce que', psk: 'parce que',
    cb: 'combien', cmb: 'combien', cbn: 'combien', cbien: 'combien', kombien: 'combien', konbien: 'combien', combin: 'combien', conbien: 'combien',
    cmt: 'comment', cmnt: 'comment', koman: 'comment', comman: 'comment', commen: 'comment',
    koi: 'quoi', kwa: 'quoi', kel: 'quel', kels: 'quels', kelle: 'quelle', kelles: 'quelles', ki: 'qui', ke: 'que', kan: 'quand', kand: 'quand', qd: 'quand', qnd: 'quand',
    jsp: 'je sais pas', chui: 'je suis', jsuis: 'je suis', jss: 'je suis', jai: 'j ai', jveux: 'je veux', jvx: 'je veux', jvoudrais: 'je voudrais', jvoudrai: 'je voudrais', jpeux: 'je peux', jaimerais: 'j aimerais', jaimerai: 'j aimerais',
    cest: 'c est', jvais: 'je vais', jsais: 'je sais', quest: 'qu est', kest: 'qu est', esk: 'est ce que', eske: 'est ce que', estce: 'est ce', ske: 'est ce que', keske: 'qu est ce que', kesk: 'qu est ce que', ya: 'il y a', yen: 'il y en', yaura: 'il y aura',
    svp: '', stp: '', slvp: '', plz: '', pls: '', please: '',
    vs: 'vous', ns: 'nous', pr: 'pour', ds: 'dans', dc: 'donc', tt: 'tout', tte: 'toute', tjr: 'toujours', tjrs: 'toujours', bcp: 'beaucoup', mtn: 'maintenant', dla: 'de la', auj: 'aujourd hui', ajd: 'aujourd hui', aujourdhui: 'aujourd hui', dmn: 'demain', sa: 'ca',
    cmd: 'commande', cde: 'commande', cmde: 'commande', liv: 'livraison', dispo: 'disponible', dispos: 'disponible', remb: 'remboursement', rembours: 'remboursement', infos: 'informations', info: 'information', gratos: 'gratuit', dat: 'date', pri: 'prix', tps: 'temps', tmps: 'temps', jr: 'jour', jrs: 'jours', tel: 'telephone', insta: 'instagram', reduc: 'reduction', promos: 'promo', colissimo: 'la poste', appli: 'application',
    bjr: 'bonjour', bjour: 'bonjour', bnjr: 'bonjour', bsr: 'bonsoir', slt: 'salut', cc: 'coucou', mrc: 'merci', mci: 'merci', thx: 'merci', thanks: 'merci', dac: 'daccord', dacc: 'daccord', dak: 'daccord', oki: 'ok', okay: 'ok', okk: 'ok', okok: 'ok',
  };
  // « fdp » ne vaut « frais de port » que dans une phrase qui parle d'argent ou de livraison.
  const FDP = new Set(['les', 'des', 'offert', 'offerts', 'gratuit', 'gratuits', 'combien', 'prix', 'cout', 'montant', 'quel', 'quels', 'sont', 'livraison', 'inclus', 'compris']);
  const COMMON = 'a ai aime aimerais alors an annee ans apres as au aucun aujourd aussi autre autres aux avant avec avez avoir avons beau beaucoup belle besoin bien bon bonne c ca car ce cela celle celui ces cet cette chez chose ci comme comment d dans de deja demain depuis des deux dire dis dit dois doit donc dont du elle elles en encore entre es est et etais etait ete etes etre eu faire fais fait faut fois font hier homme hommes hui ici il ils j je jour jours jusqu jusque l la le les leur leurs lui m ma madame mais maintenant mal me meme mes mettre moi moins mois mon monsieur n ne ni non nos notre nous nouveau nouvelle o on ont oui ou par parce pas peu peut peuvent peux plus possible pour pourquoi pourrais pourriez pouvez pouvoir premier premiere prendre puis puisque qu quand que quel quelle quelles quels quelqu quelque qui quoi rien s sa sais sans savoir se sera serai serait ses si sinon soit son sont sous suis sur t ta te tes toi ton tous tout toute toutes tres trois trop tu un une va vais veut veux vers voir voila vont vos votre voudrais voulez vouloir vous vrai vraiment y site sites france francais change changer changes dure durer temps vie prends prend pris compris comprends comprend comprendre comprenez fais faites aimez aimes match foot football recette capitale monde ville gars mec film musique chanson jeu jeux meteo pluie chat chien voiture maison ecole travail argent euro euros fin debut ligne lien page bouton cliquer clique ecran telephone portable ordinateur internet nom prenom ami amis fille garcon enfant enfants mere soeur famille femme heure heures minute minutes seconde secondes midi nuit matin soir semaine combien moi vraie belle beau joli jolie classe chose choses truc droit droits gagner perdre jouer envoyer savoir raconter aider aide garde garder derriere devant pose poser posee mis mise'.split(' ');

  // La base de reponses n'est chargee qu'a la premiere ouverture, pour ne pas alourdir les pages.
  let topics = [];
  const byChip = new Map();
  let kbRequest;
  const loadKB = () => {
    kbRequest ||= new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = kb;
      script.onload = () => {
        topics = window.ostriaKB({ price, inStock, buy, link, mail, free: FREE, eastern }).map((topic) => ({ ...topic, key: normalize(topic.q), hits: topic.words.map(normalize) }));
        topics.forEach((topic) => topic.chip && byChip.set(topic.chip, topic));
        [...COMMON, ...OFF_TOPIC, ...Object.values(SHORT), ...topics.flatMap((topic) => topic.hits)].join(' ').split(' ').forEach((word) => word && !/\d/.test(word) && lexicon.set(word, sound(word)));
        resolve();
      };
      script.onerror = () => resolve();
      document.head.append(script);
    });
    return kbRequest;
  };

  let cartTotal = null;
  const loadCart = () =>
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        cartTotal = cart.item_count ? cart.total_price / 100 : null;
      })
      .catch(() => {});
  const cartNote = () => {
    if (cartTotal === null) return '';
    const left = FREE - cartTotal;
    if (left <= 0) return 'Votre panier bénéficie de la livraison gratuite.';
    return `Il manque ${new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(left)} à votre panier pour la livraison gratuite.`;
  };
  const finish = (text) => withShipping(text).replace('[[panier]]', cartNote()).replace(/\s+</g, ' <').trim();

  const hello = new Date().getHours() >= 18 ? 'Bonsoir' : 'Bonjour';
  const STARTERS = ['Aide-moi à choisir', 'Livraison', 'Retours', 'Lire les chiffres'];
  const OPENERS = {
    product: `${hello}, une question sur la Classe 01 ? Je vous réponds tout de suite.`,
    index: `${hello}, puis-je vous aider à découvrir la Classe 01 ?`,
    cart: `${hello}, une question avant de finaliser votre commande ?`,
    article: `${hello}, une question sur cet article ou sur la Classe 01 ?`,
    blog: `${hello}, vous cherchez un conseil pour choisir votre montre ?`,
    collection: `${hello}, puis-je vous présenter la Classe 01 ?`,
  };

  // Nombre de fautes entre deux mots : lettre oubliee, en trop, remplacee ou inversee.
  const distance = (a, b) => {
    const rows = [...Array(a.length + 1)].map((_, i) => [i]);
    for (let j = 1; j <= b.length; j += 1) rows[0][j] = j;
    for (let i = 1; i <= a.length; i += 1) {
      for (let j = 1; j <= b.length; j += 1) {
        rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1);
      }
    }
    return rows[a.length][b.length];
  };

  // Cle phonetique du francais : « livrézon », « garentie » ou « rembourcemant » retrouvent leur mot.
  const sound = (word) =>
    word
      .replace(/ph/g, 'f').replace(/qu?/g, 'k').replace(/c([eiy])/g, 's$1').replace(/c(?!h)/g, 'k').replace(/gu([eiy])/g, 'g$1').replace(/g([eiy])/g, 'j$1').replace(/tion/g, 'sion')
      .replace(/[ae]i[nm](?![aeiouy])/g, '1').replace(/eau|au/g, 'o').replace(/ai|ei/g, 'e')
      .replace(/[iyu][nm](?![aeiouy])/g, '1').replace(/[ae][nm](?![aeiouy])/g, '2').replace(/o[nm](?![aeiouy])/g, '3')
      .replace(/y/g, 'i').replace(/w/g, 'v').replace(/z/g, 's').replace(/([^cs])h/g, '$1').replace(/^h/, '').replace(/(.)\1+/g, '$1')
      .replace(/(er|ez|et)$/, 'e').replace(/[estxdp]+$/, '');

  const lexicon = new Map();
  const corrected = new Map();
  const correct = (word) => {
    if (word.length < 3 || /\d/.test(word) || lexicon.has(word) || !lexicon.size) return word;
    if (corrected.has(word)) return corrected.get(word);
    // Apostrophe oubliee : « lheure », « ladresse », « letancheite ».
    const elision = word.match(/^(l|d|j|m|n|s|t|qu)([aeiouyh].+)$/);
    if (elision && lexicon.has(elision[2])) return `${elision[1]} ${elision[2]}`;
    const limit = word.length >= 8 ? 2 : word.length >= 4 ? 1 : 0;
    const key = sound(word);
    let best = word;
    let rank = 9;
    for (const [known, knownSound] of lexicon) {
      if (Math.abs(known.length - word.length) > 2) continue;
      // Jamais de correction vers un mot sensible : « site » ne doit pas devenir un mot grossier.
      if (offWords.has(known)) continue;
      let value = limit ? distance(word, known) : 9;
      // Deux fautes ne passent que si les mots se prononcent presque pareil : « raconter » n'est pas « remonter ».
      if (value === 2 && distance(key, knownSound) > 1) value = 9;
      if (value > limit) value = known.length >= 4 && key.length >= 3 && key === knownSound ? 0.9 : 9;
      if (value < rank || (value === rank && known[0] === word[0] && best[0] !== word[0])) {
        best = known;
        rank = value;
      }
    }
    corrected.set(word, best);
    return best;
  };
  const understand = (question) => {
    const words = normalize(question).replace(/([a-z])\1{2,}/g, '$1').split(' ');
    return words
      .map((word) => (word === 'fdp' && words.some((other) => FDP.has(other)) ? 'frais de port' : SHORT[word] ?? correct(word)))
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const verdict = (cm) =>
    cm < 15.5 ? 'Les 42 mm se remarqueront : une présence affirmée, que sa finesse de 10,3 mm garde confortable.'
      : cm < 17.5 ? 'Les 42 mm occuperont bien votre poignet sans le dépasser : un équilibre très porté.'
      : cm < 20 ? 'C’est son format idéal : lisible et présente, jamais démesurée.'
      : 'Les 42 mm resteront proportionnés. Vérifiez avec nous la longueur du bracelet avant de commander.';

  const wrist = (text) => {
    const match = text.match(/(\d{2})(?: (\d))?\s*(cm|centimetre)?/);
    if (!match) return null;
    const mentioned = match[3] || /poignet/.test(text);
    const cm = Number(`${match[1]}.${match[2] || 0}`);
    if (!mentioned || cm < 13 || cm > 24) return null;
    return { id: 'wrist', text: `Pour ${String(cm).replace('.', ',')} cm : ${verdict(cm)}${buy}`, chips: ['Bracelet', 'Retours'] };
  };

  // Transcrit un nombre : l'atout le plus singulier d'un cadran a chiffres orientaux.
  const transcribe = (text) => {
    const number = text.match(/\b\d{1,8}\b/);
    if (!number || !/(ecri|tradui|convert|transcri|orientaux|oriental)/.test(text)) return null;
    return { id: 'number', text: `${number[0]} s’écrit ${eastern(number[0])} en chiffres orientaux.`, chips: ['Lire les chiffres', 'Aide-moi à choisir'] };
  };

  /* Parcours guide en trois questions, conclu par un avis honnete. */
  const FLOW = [
    { key: 'wrist', ask: 'Avec plaisir. Quel est votre tour de poignet ?', chips: ['Moins de 16 cm', '16 à 18 cm', '18 à 20 cm', 'Plus de 20 cm', 'Je ne sais pas'] },
    { key: 'use', ask: 'Quand la porterez-vous le plus souvent ?', chips: ['Tous les jours', 'Au bureau', 'En sortie', 'Pour le sport'] },
    { key: 'who', ask: 'Est-ce pour vous, ou pour offrir ?', chips: ['Pour moi', 'Pour offrir'] },
  ];
  const WRIST = { 'Moins de 16 cm': 15, '16 à 18 cm': 17, '18 à 20 cm': 19, 'Plus de 20 cm': 21 };
  const USE = {
    'Tous les jours': 'Pour tous les jours, l’acier 316L et les 5 ATM couvrent la vie courante.',
    'Au bureau': 'Au bureau, son bleu sobre et ses 10,3 mm passent sous une manchette.',
    'En sortie': 'En sortie, son cadran soleillé et ses chiffres orientaux font tout son caractère.',
    'Pour le sport': 'Pour le sport intense, retirez-la le temps de la séance : vous préservez son poli et son verre, et elle vous attend pour le reste de la journée.',
  };
  const WHO = {
    'Pour moi': 'Vous gardez 14 jours après réception pour changer d’avis.',
    'Pour offrir': 'Elle arrive dans son écrin Ostria, prête à offrir, et le délai de 14 jours vous laisse le droit à l’erreur.',
  };
  const state = { flow: -1, picks: {}, last: null };
  const flowStep = () => ({ id: 'flow', text: FLOW[state.flow].ask, chips: FLOW[state.flow].chips });
  const flowEnd = () => {
    const { wrist: size, use, who } = state.picks;
    const cm = WRIST[size];
    const fit = cm ? verdict(cm) : `Mesurez votre poignet avec une bande de papier, ou essayez notre ${link('/pages/guide-des-tailles', 'simulateur')}.`;
    state.flow = -1;
    return { id: 'flow-end', text: `Voici mon avis. ${fit} ${USE[use] || ''} ${WHO[who] || ''}${buy}`, chips: ['Livraison', 'Retours', 'Code promo'] };
  };

  const score = (topic, text, padded) => {
    let value = 0;
    for (const word of topic.hits) {
      // Les mots courts doivent etre exacts : « vol » ne doit pas repondre a « volante ».
      if (padded.includes(` ${word} `) || padded.includes(` ${word}s `) || (word.length >= 5 && padded.includes(` ${word}`))) value += 1 + (word.split(' ').length - 1) * 1.5;
    }
    if (topic.key === text) value += 10;
    return value * (topic.weight || 1);
  };

  // Hors repertoire, troll ou question genante : toujours la meme reponse.
  const GENERIC = {
    id: 'generic',
    text: `Je n’ai pas cette information. Notre équipe vous répondra volontiers à ${mail}.`,
    go: ['/pages/contact', 'Contacter l’équipe'],
    chips: STARTERS,
  };
  const OFF_TOPIC = ['trop cher', 'cher', 'chere', 'arnaque', 'arnaqueur', 'arnaques', 'escroc', 'escroquerie', 'scam', 'fraude', 'fake', 'voleur', 'voleurs', 'nul', 'nulle', 'merde', 'con', 'connard', 'conne', 'pute', 'salope', 'encule', 'fdp', 'ntm', 'tg', 'bite', 'sexe', 'dropshipping', 'dropship', 'chine', 'chinois', 'chinoise', 'aliexpress', 'temu', 'shein', 'alibaba', 'contrefacon', 'copie', 'replique', 'fausse', 'avis', 'note', 'trustpilot', 'marge', 'gagnes', 'gagne', 'gagnez', 'prix d achat', 'benefice', 'chiffre d affaires', 'salaire', 'ton age', 'quel age as tu', 'quel age tu as', 'quel age avez vous', 'marie', 'mariee', 'celibataire', 'politique', 'religion', 'religieux', 'guerre', 'raciste', 'racisme', 'drogue', 'arme', 'pirate', 'hacker', 'hacke', 'hacking', 'moche', 'sale bot', 'sale robot', 'suicide', 'suicider', 'suicidaire', 'me tuer', 'en finir', 'envie de mourir', 'veux mourir', 'me pendre', 'plus envie de vivre'];
  const OFF_PATTERN = new RegExp(`\\b(${OFF_TOPIC.join('|')})\\b`);
  const offWords = new Set(OFF_TOPIC.join(' ').split(' '));
  // Expressions anodines qui contiennent un mot de la liste ci-dessus.
  const SAFE = / avis de passage | note (du|de) (panier|commande) | fausse adresse | politique de (confidentialite|retour|livraison|remboursement) /g;

  const answer = (question) => {
    if (state.flow >= 0 && FLOW[state.flow].chips.includes(question)) {
      state.picks[FLOW[state.flow].key] = question;
      state.flow += 1;
      return state.flow < FLOW.length ? flowStep() : flowEnd();
    }
    state.flow = -1;
    const chipped = byChip.get(question);
    if (chipped) {
      if (chipped.flow) {
        state.flow = 0;
        state.picks = {};
        return flowStep();
      }
      return chipped;
    }
    const text = understand(question);
    const padded = ` ${text} `;
    if (OFF_PATTERN.test(padded.replace(SAFE, ' '))) return GENERIC;
    const special = transcribe(text) || wrist(text);
    if (special) return special;
    const ranked = topics
      .map((topic) => ({ topic, value: score(topic, text, padded) }))
      .filter((item) => item.value > 0)
      .sort((a, b) => b.value - a.value);
    if (!ranked.length || ranked[0].topic.unknown) return GENERIC;
    const [first, second] = ranked;
    if (first.topic.flow) {
      state.flow = 0;
      state.picks = {};
      return flowStep();
    }
    const value = (topic) => (typeof topic.text === 'function' ? topic.text() : topic.text);
    // Deux sujets dans une meme question : les deux reponses, dans l'ordre de pertinence.
    const linked = / et | ainsi que | puis /.test(padded);
    if (second && !second.topic.flow && !second.topic.unknown && !first.topic.social && !second.topic.social && second.value >= first.value * (linked ? 0.5 : 0.85) && second.value >= (linked ? 1 : 1.5)) {
      return { id: 'double', go: first.topic.go, text: `${value(first.topic)}<br><br>${value(second.topic)}`, chips: [...new Set([...(first.topic.chips || []), ...(second.topic.chips || [])])].slice(0, 4) };
    }
    return first.topic;
  };
  const speak = (result) => {
    const text = finish(typeof result.text === 'function' ? result.text() : result.text);
    return result.go ? `${text}<a class="o-chat__go" href="${result.go[0]}">${result.go[1]} →</a>` : text;
  };
  root.reply = async (question) => {
    await Promise.all([loadKB(), loadShipping(), loadCart()]);
    return speak(answer(question));
  };

  const store = {
    read() {
      try {
        return JSON.parse(sessionStorage.getItem('o-chat') || '[]');
      } catch {
        return [];
      }
    },
    write(log) {
      try {
        sessionStorage.setItem('o-chat', JSON.stringify(log.slice(-30)));
      } catch {
        // Conversation simplement non conservee.
      }
    },
  };

  const start = () => {
    // Shopify Inbox prend le relais s'il est installe.
    if (customElements.get('shopify-chat')) return;

    root.className = 'o-chat';
    root.innerHTML = `
      <div class="o-chat__nudge" data-nudge hidden>
        <button type="button" class="o-chat__nudge-text" data-open></button>
        <button type="button" class="o-chat__x" data-dismiss aria-label="Fermer ce message">×</button>
      </div>
      <section class="o-chat__panel" id="o-chat-panel" role="dialog" aria-label="Concierge Ostria" hidden>
        <header class="o-chat__head">
          <div><strong>Concierge Ostria</strong><small>Assistant automatique, pas un conseiller humain</small></div>
          <button type="button" class="o-chat__x" data-close aria-label="Fermer le concierge">×</button>
        </header>
        <p class="o-chat__legal">N’indiquez ni données bancaires ni mot de passe. Vos messages restent dans votre navigateur et disparaissent à la fermeture de l’onglet. <button type="button" data-clear>Effacer</button></p>
        <div class="o-chat__log" data-log role="log" aria-live="polite"></div>
        <div class="o-chat__chips" data-chips></div>
        <form class="o-chat__form" data-form>
          <input data-input type="text" aria-label="Votre question" placeholder="Posez votre question" autocomplete="off" maxlength="200">
          <button type="submit">Envoyer</button>
        </form>
      </section>
      <button type="button" class="o-chat__fab" data-toggle aria-expanded="false" aria-controls="o-chat-panel" aria-label="Ouvrir le concierge Ostria">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 5h16v11H9l-5 4z"/></svg>
        <span class="o-chat__dot" data-dot hidden></span>
      </button>`;

    const $ = (selector) => root.querySelector(selector);
    const panel = $('.o-chat__panel');
    const fab = $('[data-toggle]');
    const log = $('[data-log]');
    const nudge = $('[data-nudge]');
    const input = $('[data-input]');
    const chipsBox = $('[data-chips]');
    const opener = OPENERS[page] || `${hello}, puis-je vous renseigner ?`;
    const history = store.read();
    let timer = 0;

    const draw = (who, content) => {
      const item = document.createElement('div');
      item.className = `o-chat__msg o-chat__msg--${who}`;
      if (who === 'user') item.textContent = content;
      else item.innerHTML = content;
      log.append(item);
      log.scrollTop = log.scrollHeight;
    };
    const add = (who, content) => {
      draw(who, content);
      history.push([who, content]);
      store.write(history);
    };
    const chips = (labels) => {
      chipsBox.textContent = '';
      for (const label of labels) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.textContent = label;
        chip.addEventListener('click', () => ask(label));
        chipsBox.append(chip);
      }
    };
    const ask = (question) => {
      add('user', question);
      chips([]);
      const typing = document.createElement('div');
      typing.className = 'o-chat__typing';
      typing.setAttribute('aria-label', 'Le concierge écrit');
      typing.innerHTML = '<i></i><i></i><i></i>';
      log.append(typing);
      log.scrollTop = log.scrollHeight;
      Promise.all([loadKB(), loadShipping(), loadCart()]).then(() => {
        const result = answer(question);
        const reply = speak(result);
        setTimeout(() => {
          typing.remove();
          add('bot', reply);
          chips(result.chips || STARTERS);
        }, Math.min(900, 380 + reply.length));
      });
    };
    const setOpen = (open) => {
      clearTimeout(timer);
      nudge.hidden = true;
      $('[data-dot]').hidden = true;
      panel.hidden = !open;
      fab.setAttribute('aria-expanded', String(open));
      if (!open) {
        fab.focus();
        return;
      }
      loadKB();
      loadShipping();
      loadCart();
      if (!history.length) {
        add('bot', opener);
        chips(STARTERS);
      }
      log.scrollTop = log.scrollHeight;
      input.focus();
    };

    history.forEach(([who, content]) => draw(who, content));
    if (history.length) chips(STARTERS);

    fab.addEventListener('click', () => setOpen(panel.hidden));
    $('[data-close]').addEventListener('click', () => setOpen(false));
    $('[data-clear]').addEventListener('click', () => {
      history.length = 0;
      store.write(history);
      log.textContent = '';
      add('bot', opener);
      chips(STARTERS);
    });
    $('[data-open]').addEventListener('click', () => setOpen(true));
    $('[data-dismiss]').addEventListener('click', () => {
      nudge.hidden = true;
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) setOpen(false);
    });
    $('[data-form]').addEventListener('submit', (event) => {
      event.preventDefault();
      const question = input.value.trim();
      if (!question) return;
      input.value = '';
      ask(question);
    });

    let shown = false;
    try {
      shown = Boolean(sessionStorage.getItem('o-nudge'));
    } catch {
      shown = true;
    }
    if (shown || history.length) return;
    timer = window.setTimeout(() => {
      if (!panel.hidden) return;
      $('[data-open]').textContent = opener;
      nudge.hidden = false;
      $('[data-dot]').hidden = false;
      try {
        sessionStorage.setItem('o-nudge', '1');
      } catch {
        // Le message s'affichera simplement a chaque page.
      }
    }, 20000 + Math.random() * 10000);
  };

  // Laisse a Shopify Inbox le temps de s'enregistrer avant de se monter.
  setTimeout(start, 1500);
})();
